import {css} from 'lit';
export const styles = css`:host {
  display: block;
  height: 100%;
}

main {
  height: 100%;
  overflow: auto;
  display: block;
  position: relative;
}

.content {
  position: relative;
  z-index: 10;
  height: 100%;
}

header {
  position: absolute;
  top: 0;
  left: 0;
  height: 50%;
  width: 100%;
  z-index: 0;
}
`;
export default styles;
